module.exports = __webpack_public_path__ + "img/user.6ecf240a.jpeg";